
import {
  TYPE_JUMP_APP,
  TYPE_JUMP_WEB,
  TYPE_JUMP_WEAPP,
} from "./constant/types";

export default {
  // 获取url参数
  getUrlParam(evn) {
    // 取参数
    const url = evn;
    // 定义一个空对象
    const urlObj = {};
    // 如果字符串里面存在?
    if (url.indexOf('?') !== -1) {
      const params = url.split('?')[1];
      const param = params.split('&');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < param.length; i++) {
        const paramsA = param[i].split('=');
        const key = paramsA[0];
        const value = paramsA[1];
        urlObj[key] = value;
      }
    }
    return urlObj;
  },
  getParam(params) {
    // 定义一个空对象
    const urlObj = {};
    const param = params.split('&');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < param.length; i++) {
      const paramsA = param[i].split('=');
      const key = paramsA[0];
      const value = paramsA[1];
      urlObj[key] = value;
    }
    return urlObj;
  },
  removeCodeParameter(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.delete('code');
    return urlObj.toString();
  },
  // 空字符检测
  isEmptyString(str) {
    if (str.trim() === "" || str.trim() === null || str.trim() === undefined) return true;
    const regex = /^\s*$/;
    return regex.test(str.trim());
  },
  // 手机合法性校验
  isValidPhoneNumber(phoneNumber) {
    return /^[0-9]+$/.test(phoneNumber);
  },
  // 手机合法性校验
  //   isValidPhoneNumber(phoneNumber) {
  //     const regex = /^1[3456789]\d{9}$/;
  //     return regex.test(phoneNumber);
  //   },

  /**
   * 跳转
   * @param {*} type 跳转类型
   * @param {*} link 跳转链接
   */
  openBrand(type, link) {
    // 逻辑：
    // 1. TYPE_JUMP_APP 和 TYPE_JUMP_WEB 和 TYPE_JUMP_WEAPP 跳转网页
    if (!this.isEmptyString(link)) {
      if (type === TYPE_JUMP_APP || type === TYPE_JUMP_WEB || type === TYPE_JUMP_WEAPP) {
        window.location.href = link;
        // window.open(link);
      }
    }
  },

  /**
   * 将接口返回的省市区数据 格式化为 vant省市区联动组件需要的格式
   * @param {*} areas 接口返回的省市区数据 格式化为 vant省市区联动组件需要的格式
   * 后端返回的嵌套对象属性名都不一样。。。 无法递归
   */
  fomartAreaDataToVant(dataArr) {
    if (!dataArr || !Array.isArray(dataArr) || dataArr.length === 0) return [];
    const _provinceArr = [];
    dataArr.forEach((province, pIdx) => {
      if (Array.isArray(province.s)) {
        const _cityArr = [];
        province.s.forEach((city, cIdx) => {
          if (Array.isArray(city.q)) {
            const _areaArr = [];
            city.q.forEach((area) => {
              _areaArr.push({
                text: area.n,
                value: area.i
              });
            });
            _cityArr.push({
              text: city.c,
              value: cIdx,
              children: _areaArr
            });
          }
        });
        _provinceArr.push({
          text: province.p,
          value: pIdx,
          children: _cityArr
        });
      }
    });
    return _provinceArr;
  },

  isWechatBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') !== -1;
    return isWeixin;
  },
  isHideNavBar() {
    const ua = navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') !== -1;
    const isDouyin = ua.indexOf('bytedance') !== -1;
    const isWeibo = ua.indexOf('weibo') !== -1;
    const param = this.getUrlParam(window.location.href);
    // eslint-disable-next-line eqeqeq
    return isWeixin || isDouyin || isWeibo || param.hidenav == 1;
  }
};